import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const baseUrl = createApiUrl('/api/terminology/')

const retrieve = async (query = '', page = 1) => {
    const pageParam = `page=${page}`
    const queryString = [query, pageParam].filter(Boolean).join('&')
    const res = await axios.get(`${baseUrl}?${queryString}`, tokenService.getAuthHeader())
    return res.data
}

const retrieveSingle = async (id) => {
    const res = await axios.get(`${baseUrl}${id}/`, tokenService.getAuthHeader())
    return res.data
}

const create = async (obj) => {
    const res = await axios.post(baseUrl, obj, tokenService.getAuthHeader())
    return res.data
}

const update = async (id, obj) => {
    const res = await axios.put(`${baseUrl}${id}/`, obj, tokenService.getAuthHeader())
    return res.data
}

const destroy = async (id) => {
    const res = await axios.delete(`${baseUrl}${id}/`, tokenService.getAuthHeader())
    return res
}

const retrieveAllForAdmin = async (searchQuery = '', page = 1, approved = null, ordering = null) => {
    const params = []
    if (searchQuery) params.push(`search=${encodeURIComponent(searchQuery)}`)
    if (page) params.push(`page=${page}`)
    if (approved !== null) params.push(`approved=${approved}`)
    if (ordering) params.push(`ordering=${ordering}`)

    const queryString = params.length > 0 ? `?${params.join('&')}` : ''
    const res = await axios.get(`${baseUrl}admin/all/${queryString}`, tokenService.getAuthHeader())
    return res.data
}

const retrieveRevisions = async (page = 1, ordering = null) => {
    const pageParam = `page=${page}`
    const orderingParam = ordering ? `ordering=${ordering}` : ''
    const queryString = [pageParam, orderingParam].filter(Boolean).join('&')
    const res = await axios.get(`${baseUrl}admin/revisions/all/?${queryString}`, tokenService.getAuthHeader())
    return res.data
}

const retrieveSingleRevision = async (id) => {
    const res = await axios.get(`${baseUrl}admin/revisions/${id}`, tokenService.getAuthHeader())
    return res.data
}

const createRevision = async (obj) => {
    const res = await axios.post(`${baseUrl}revisions/`, obj, tokenService.getAuthHeader())
    return res.data
}

const destroyRevision = async (id) => {
    const res = await axios.delete(`${baseUrl}admin/revisions/${id}/`, tokenService.getAuthHeader())
    return res
}

const acceptRevision = async (id) => {
    const res = await axios.post(`${baseUrl}admin/revisions/${id}/accept/`, {}, tokenService.getAuthHeader())
    return res
}

const getLastUpdated = async () => {
    const res = await axios.get(`${baseUrl}last-updated/`, tokenService.getAuthHeader())
    return res.data.last_updated
}

const getExportUrl = (format) => `${baseUrl}export/?format=${format}`

const terminologyService = {
    retrieve,
    retrieveSingle,
    create,
    update,
    destroy,
    retrieveAllForAdmin,
    retrieveRevisions,
    retrieveSingleRevision,
    createRevision,
    destroyRevision,
    acceptRevision,
    getLastUpdated,
    getExportUrl,
}

export default terminologyService
